/**
 * Форма «Получить консультацию» — модалка `template/modals/get-consultation.php`,
 * блок `template/components/get-consultation.php`.
 *
 *
 * ⚠️ `initCustomForm` — глобальная функция обычного скрипта, а не
 * модуля. Нужен набор `prism_enqueue_set('custom-form')` в блоке
 * страницы, иначе форма молча не заработает — отсюда проверка ниже.
 */

/** Идентификатор счётчика Яндекс.Метрики. */
const METRICA_ID = 59852344;

/**
 * UTM по умолчанию — как у прежнего попапа. Метки из адреса
 * страницы `initCustomForm` ставит поверх них сам.
 */
const UTM_DEFAULTS = {
    utm_source: 'seo',
    utm_medium: 'organic',
    utm_campaign: 'consultation',
    utm_term: 'consultation',
};

/** Безопасный вызов цели: заглушка `window.ym` живёт в футере. */
function reachGoal(goal) {
    if (typeof window.ym === 'function') {
        window.ym(METRICA_ID, 'reachGoal', goal);
    }
}

/**
 * Модалки на странице.
 *
 * 🔴 На `/pcc/` класс `Modals` уже поднимает `page-basic-coaching.js`.
 * Второй экземпляр повесил бы второй обработчик клика, и модалка
 * открывалась бы дважды.
 *
 * ⚠️ `window.modals` проверяется ПОСЛЕ `await import()`, а не до:
 * порядок обработчиков `DOMContentLoaded` у бандла и легаси-модулей
 * не гарантирован. Vite кладёт `init-modals.js` отдельным чанком,
 * его загрузка завершается уже после всех обработчиков события.
 */
async function ensureModals() {
    const { initModals } = await import('../../../assets/js/modals/init-modals.js');

    if (!window.modals) {
        initModals();
    }
}

function initForm(container) {
    const handleResponse = (response) => {
        const result = response.result;

        if (result && result.success) {
            customFormMessageSuccess(container);
            reachGoal('lid-forma-pervy-ekran');
            return;
        }

        console.error('consultation-form: GetCourse вернул ошибку', response);
        customFormMessageError(container, 'Произошла ошибка при отправке заявки, попробуйте позднее');
    };

    initCustomForm(
        container,
        '/gc/gc-post.php',
        {
            ...UTM_DEFAULTS,
            utm_content: window.location.pathname,
        },
        handleResponse,
        {
            comment: `Страница: ${window.location.origin + window.location.pathname}`,
        },
    );
}

export default async function ConsultationForm() {
    const container = document.querySelector('.custom-form--get-consultation');
    if (!container) return;

    if (typeof initCustomForm !== 'function') {
        console.error('consultation-form: не подключён assets/js/custom-form.js (набор custom-form)');
        return;
    }

    await ensureModals();
    initForm(container);

    // Цель показа
    document.querySelectorAll('[data-open-modal="get-consultation"]').forEach((button) => {
        button.addEventListener('click', () => reachGoal('pokaz-forma-pervy-ekran'));
    });
}
